import { sameMembers } from '@nx-smartmonkey/shared/helpers';
import { SelectionActionType } from '../../context/selection/actions';
import { useSelectionContext } from '../../context/selection/context';
import { useRetrieveActivePlanStops } from './useRetrieveActivePlanStops';

type UseSetActivePlanSelectedStopsResponse = {
  setSelectedStops: (selectedStops: Array<string>) => void;
  selectedStops: Array<string>;
  selectStopFromMap: ({ stopId, withControlKey }: { stopId: string; withControlKey?: boolean }) => void;
};

// Hooks act as 'Adapter' layer.
export const useSetActivePlanSelectedStops = (): UseSetActivePlanSelectedStopsResponse => {
  const { selectionState, selectionDispatch } = useSelectionContext();
  const { map: stopsMap } = useRetrieveActivePlanStops();

  const setSelectedStops = (selectedStops: Array<string>) => {
    if (!stopsMap) return;
    if (!sameMembers(selectionState.selectedStops, selectedStops)) {
      const pickups = selectedStops.filter((stopId) => stopsMap[stopId]?.type === `pickup`);
      const deliveries = selectedStops.filter((stopId) => stopsMap[stopId]?.type === `delivery`);
      selectionDispatch({
        type: SelectionActionType.SET_ACTIVE_PLAN_SELECTED_STOPS,
        payload: {
          selectedStops: [...pickups, ...deliveries],
        },
      });
    }
  };

  const selectStopFromMap = ({ stopId, withControlKey }: { stopId: string; withControlKey?: boolean }) => {
    selectionDispatch({
      type: SelectionActionType.ON_SELECT_STOP,
      payload: {
        stopId,
        withControlKey,
      },
    });

    if (selectionState.selectedDrivers.length > 0) {
      selectionDispatch({
        type: SelectionActionType.SET_ACTIVE_PLAN_SELECTED_DRIVERS,
        payload: {
          selectedDrivers: [],
        },
      });
    }
  };

  return {
    setSelectedStops,
    selectedStops: selectionState.selectedStops,
    selectStopFromMap: selectStopFromMap,
  };
};
